import { render, staticRenderFns } from "./ComplaintManage.vue?vue&type=template&id=862d9468&scoped=true&"
import script from "./ComplaintManage.vue?vue&type=script&lang=js&"
export * from "./ComplaintManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862d9468",
  null
  
)

export default component.exports